import AwbSummary from './AwbSummary'

export default AwbSummary
